module.exports = __webpack_public_path__ + "img/parkActivities.f8951b8b.svg";